import React, { FC } from 'react';
import { AccountTile } from '../../../Account/MyAccount/AccountTile';
import { AccountTileListItem } from '../../../Account/MyAccount/AccountTileListItem';
import { Button } from '../../../shared/Button';
import { Heading } from '../../../shared/Heading';
import { Paragraph } from '../../../shared/Paragraph';
import { AccountTileAccountReviewItem } from './AccountTileAccountReviewItem/AccountTileAccountReviewItem';
import './AccountReviewSection.scss';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import { getAccountReviewOptions } from '../mocks';

interface AccountReviewSectionProps {
  /**
   * Optional to add a spinner before loading a component.
   */
  loading: boolean;
  /**
   * Value of the Select element in the format 'time text' (ex.: 15 minutes, 1 hours)
   */
  intervalWithLabel?: string;
  /**
   * Callback that's executed when the user opens the HowItWorks modal
   */
  openHowItWorksModal: () => void;
  /**
   * Callback that's executed when the user opens the EditModal
   */
  openEditModal: () => void;
  /**
   * Calback that's executed on remove icon click
   */
}

export const AccountReviewSection: FC<AccountReviewSectionProps> = ({
  loading,
  intervalWithLabel,
  openHowItWorksModal,
  openEditModal,
}) => {
  const { t } = useTranslations();

  const getLabelFromValue = (value: string): string => {
    const options = getAccountReviewOptions(t);
    const option = options.find((opt) => opt.value === value);

    return option?.label || value;
  };

  const text = intervalWithLabel ? getLabelFromValue(intervalWithLabel) : t('account-review.limit.add.text');

  return (
    <div className="account-review-section">
      <Heading level={6}>{t('account-review.tools.title')}</Heading>

      <Paragraph className="account-review-section__subtext" size="xs" noMargin>
        {t('account-review.limit.info')}
        <Button type="button" variant="text" className="account-review-section__link" onClick={openHowItWorksModal}>
          {t('account-review.how-it-works.title')}
        </Button>
      </Paragraph>

      <AccountTile noPadding>
        {intervalWithLabel ? (
          <AccountTileAccountReviewItem text={text} onOpenEditModal={openEditModal} />
        ) : (
          <AccountTileListItem loading={loading} text={text} icon="Plus" iconAlign="right" onClick={openEditModal} />
        )}
      </AccountTile>
    </div>
  );
};
